import { Node } from '../Node';
import { NodeModelTypeEnum } from '../enums';

export class PHSensorNodeModel extends Node {
  constructor(device?, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.PhSensor,
    });
  }
}
